import { useCallback, useEffect, useState } from "react";
import { LunavoaApiError } from "@lunavoa/api-client";

export type AsyncState<T> = { data: T | null; loading: boolean; error: LunavoaApiError | null; reload: () => void };

export function useAsync<T>(load: () => Promise<T>, dependencies: readonly unknown[] = []): AsyncState<T> {
  const [state, setState] = useState<{ data: T | null; loading: boolean; error: LunavoaApiError | null }>({ data: null, loading: true, error: null });
  const [revision, setRevision] = useState(0);
  const reload = useCallback(() => setRevision((value) => value + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    setState((current) => ({ ...current, loading: true, error: null }));
    load().then((data) => { if (!controller.signal.aborted) setState({ data, loading: false, error: null }); })
      .catch((error: unknown) => { if (!controller.signal.aborted) setState({ data: null, loading: false, error: error instanceof LunavoaApiError ? error : new LunavoaApiError("This view could not be loaded.", 500, "unknown", false) }); });
    return () => controller.abort();
  }, [...dependencies, revision]);
  return { ...state, reload };
}
